import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	mailMeta: {},
	selectedFile: {},
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadMailMeta(state, mm) {
			state.mailMeta = JSON.parse(JSON.stringify(mm));
		},
		setSelectedFile(state, sf) {
			state.selectedFile = JSON.parse(JSON.stringify(sf));
		},
		setCurrentLogs(state, logs) {
			state.currentLogs = logs;
		},
		refreshStockistListEmitter(state) {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getMailMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.REJECTED_META,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						commit('loadMailMeta', data.files);
						return data;
					} else {
						fail(data.message || 'Failed to load Mail meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getFileJSON: ({ commit, dispatch }, { renderMode, filePathURL }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {},
					url:
						renderMode == 'parsed'
							? constants.UTILITY_PARSED_FILE + filePathURL
							: constants.UTILITY_TRANSFORMED_FILE + filePathURL,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getFileMeta: ({ commit, dispatch }, metaId) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {
						metaUsed: metaId,
					},
					url: constants.UTILITY_FILE_META,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getExtractedOutput: ({ commit, dispatch }, params) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: params,
					url: constants.UTILITY_EXTRACTED_OUTPUT,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		downloadFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.filename.split('.')[0],
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.filename); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		mailMeta: state => state.mailMeta,
		selectedFile: state => state.selectedFile,
	},
};
